import { VNC_SESSION_STATUS } from '../util/constant';
import * as actions from './action';
import * as mutations from './mutations';
import * as queries from './queries';

export function requestMachineVncSession(machineId) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({
        type: actions.REQUEST_MACHINE_VNC_SESSION_REQUEST,
        payload: { machineId }
      });
      const clientResponse = await client.mutate({
        mutation: mutations.requestUserMachineVncSession,
        variables: {
          input: {
            machineId
          }
        }
      });

      const response = clientResponse?.data?.requestUserMachineVncSession;

      dispatch({
        type: actions.REQUEST_MACHINE_VNC_SESSION_SUCCESS,
        payload: response
      });
    } catch (error) {
      dispatch({
        type: actions.REQUEST_MACHINE_VNC_SESSION_FAIL,
        payload: { error }
      });
    }
  };
}

export function resetMachineVncSession() {
  return (dispatch) => {
    dispatch({ type: actions.REQUEST_MACHINE_VNC_SESSION_RESET_STATE });
  };
}

export function getMachineVncSessionStatus(machineId) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: actions.GET_MACHINE_VNC_SESSION_STATUS_REQUEST });
      const clientResponse = await client.query({
        query: queries.getUserMachineVncSessionStatus,
        variables: {
          input: {
            machineId
          }
        }
      });
      const response = clientResponse?.data?.getUserMachineVncSessionStatus;

      dispatch({
        type: actions.SAVE_MACHINE_VNC_SESSION_STATUS_RESPONSE,
        payload: response
      });
    } catch (error) {
      dispatch({
        type: actions.GET_MACHINE_VNC_SESSION_STATUS_FAIL,
        payload: { error }
      });
    }
  };
}

export function pollMachineVncSessionStatusResult(statusResponse) {
  return (dispatch) => {
    if (
      !statusResponse.includes(VNC_SESSION_STATUS.RUNNING) ||
      statusResponse.includes(VNC_SESSION_STATUS.FAILED)
    ) {
      dispatch({
        type: actions.SHOW_MACHINE_VNC_SESSION_STATUS_MODAL
      });

      dispatch({
        type: actions.GET_MACHINE_VNC_SESSION_STATUS_SUCCESS,
        payload: false
      });
    }
    if (statusResponse.includes(VNC_SESSION_STATUS.RUNNING)) {
      dispatch({
        type: actions.GET_MACHINE_VNC_SESSION_STATUS_SUCCESS,
        payload: true
      });
    }
  };
}

export function resetMachineVncSessionStatus() {
  return (dispatch) => {
    dispatch({ type: actions.GET_MACHINE_VNC_SESSION_STATUS_RESET_STATE });
  };
}

export function showMachineVncSessionStatusModal() {
  return (dispatch) => {
    dispatch({ type: actions.SHOW_MACHINE_VNC_SESSION_STATUS_MODAL });
  };
}

export function hideMachineVncSessionStatusModal() {
  return (dispatch) => {
    dispatch({ type: actions.HIDE_MACHINE_VNC_SESSION_STATUS_MODAL });
  };
}

export function showCheckedFirmwareModal() {
  return (dispatch) => {
    dispatch({
      type: actions.SHOW_MACHINE_VNC_SESSION_FIRMWARE_CHECKING_MODAL
    });
  };
}

export function hideCheckedFirmwareModal() {
  return (dispatch) => {
    dispatch({
      type: actions.HIDE_MACHINE_VNC_SESSION_FIRMWARE_CHECKING_MODAL
    });
  };
}

export function checkVncCachedUrlSession(machineId) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: actions.CHECK_MACHINE_VNC_CACHED_SESSION_REQUEST });
      const clientResponse = await client.query({
        query: queries.getUserMachineVncSessionStatus,
        variables: {
          input: {
            machineId
          }
        }
      });
      const response = clientResponse?.data?.getUserMachineVncSessionStatus;

      dispatch({
        type: actions.CHECK_MACHINE_VNC_CACHED_SESSION_SUCCESS,
        payload: response
      });
    } catch (error) {
      dispatch({
        type: actions.CHECK_MACHINE_VNC_CACHED_SESSION_FAIL,
        payload: { error }
      });
    }
  };
}

export function resetCheckVncCachedUrlSession() {
  return (dispatch) => {
    dispatch({ type: actions.CHECK_MACHINE_VNC_CACHED_SESSION_RESET_STATE });
  };
}

export function showMachineVncExpirationModal() {
  return (dispatch) => {
    dispatch({ type: actions.SHOW_MACHINE_VNC_SESSION_EXPIRATION_MODAL });
  };
}

export function hideMachineVncExpirationModal() {
  return (dispatch) => {
    dispatch({ type: actions.HIDE_MACHINE_VNC_SESSION_EXPIRATION_MODAL });
  };
}

export function activeOpen() {
  return (dispatch) => {
    dispatch({ type: actions.OPEN });
  };
}

export function activeClose() {
  return (dispatch) => {
    dispatch({ type: actions.CLOSE });
  };
}

export function activeExpand() {
  return (dispatch) => {
    dispatch({ type: actions.EXPAND });
  };
}

export function activeUnexpand() {
  return (dispatch) => {
    dispatch({ type: actions.UNEXPAND });
  };
}

export function activeMinimize() {
  return (dispatch) => {
    dispatch({ type: actions.MINIMIZE });
  };
}

export function activeUnminimize() {
  return (dispatch) => {
    dispatch({ type: actions.UNMINIMIZE });
  };
}

export function resetVncUI() {
  return (dispatch) => {
    dispatch({ type: actions.RESET_VNC_UI });
  };
}

export function activeCachedOpen() {
  return (dispatch) => {
    dispatch({ type: actions.CACHED_OPEN });
  };
}

export function showMachineVncCheckOneAlreadyRunModal() {
  return (dispatch) => {
    dispatch({
      type: actions.SHOW_MACHINE_VNC_SESSION_CHECK_ONE_ALREADY_RUN_MODAL
    });
  };
}

export function hideMachineVncCheckOneAlreadyRunModal() {
  return (dispatch) => {
    dispatch({
      type: actions.HIDE_MACHINE_VNC_SESSION_CHECK_ONE_ALREADY_RUN_MODAL
    });
  };
}
